const TOKEN_KEY = "token";
const USER_KEY = "user";
const USER_INFO_KEY = "userInfo";

function getSessionStorage(): Storage | null {
  if (typeof window === "undefined") {
    return null;
  }

  return window.sessionStorage;
}

function getLocalStorage(): Storage | null {
  if (typeof window === "undefined") {
    return null;
  }

  return window.localStorage;
}

export function clearLegacyPersistentSession(): void {
  const storage = getLocalStorage();
  if (!storage) {
    return;
  }

  storage.removeItem(TOKEN_KEY);
  storage.removeItem(USER_KEY);
  storage.removeItem(USER_INFO_KEY);
}

export function getSessionToken(): string {
  const storage = getSessionStorage();
  return storage ? storage.getItem(TOKEN_KEY) || "" : "";
}

export function setSessionToken(token: string): void {
  const storage = getSessionStorage();
  if (storage) {
    storage.setItem(TOKEN_KEY, token);
  }
}

export function clearSessionToken(): void {
  const storage = getSessionStorage();
  if (storage) {
    storage.removeItem(TOKEN_KEY);
  }
}

export function getSessionUser<T>(fallback: T): T {
  const storage = getSessionStorage();
  if (!storage) {
    return fallback;
  }

  const value = storage.getItem(USER_KEY);
  if (!value) {
    return fallback;
  }

  try {
    return JSON.parse(value);
  } catch (error) {
    storage.removeItem(USER_KEY);
    return fallback;
  }
}

export function setSessionUser(value: any): void {
  const storage = getSessionStorage();
  if (storage) {
    storage.setItem(USER_KEY, JSON.stringify(value));
  }
}

export function clearSessionUser(): void {
  const storage = getSessionStorage();
  if (storage) {
    storage.removeItem(USER_KEY);
  }
}

export function getSessionUserInfo<T>(fallback: T): T {
  const storage = getSessionStorage();
  if (!storage) {
    return fallback;
  }

  const value = storage.getItem(USER_INFO_KEY);
  if (!value) {
    return fallback;
  }

  try {
    return JSON.parse(value);
  } catch (error) {
    storage.removeItem(USER_INFO_KEY);
    return fallback;
  }
}

export function setSessionUserInfo(value: any): void {
  const storage = getSessionStorage();
  if (storage) {
    storage.setItem(USER_INFO_KEY, JSON.stringify(value));
  }
}

export function clearSessionUserInfo(): void {
  const storage = getSessionStorage();
  if (storage) {
    storage.removeItem(USER_INFO_KEY);
  }
}

export function clearAllSessionData(): void {
  clearSessionToken();
  clearSessionUser();
  clearSessionUserInfo();
}
